var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircleGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6575 5.19664C19.8477 4.47586 23.1854 4.80562 26.1728 6.13675C26.9295 6.47392 27.8163 6.13381 28.1535 5.37711C28.4906 4.6204 28.1505 3.73363 27.3938 3.39646C23.8155 1.80204 19.8176 1.40705 15.9964 2.27039C12.1752 3.13374 8.73547 5.20917 6.19019 8.18714C3.64491 11.1651 2.13045 14.8861 1.87269 18.7951C1.61493 22.7041 2.62768 26.5917 4.75989 29.8781C6.8921 33.1645 10.0295 35.6737 13.7043 37.0313C17.379 38.3889 21.3941 38.5223 25.1509 37.4115C28.9076 36.3008 32.2047 34.0054 34.5503 30.8678C36.8959 27.7301 38.1644 23.9183 38.1667 20.0008V19.9999V18.4666C38.1667 17.6382 37.4951 16.9666 36.6667 16.9666C35.8382 16.9666 35.1667 17.6382 35.1667 18.4666V19.9991C35.1648 23.2697 34.1057 26.452 32.1475 29.0715C30.1892 31.691 27.4366 33.6073 24.3003 34.5347C21.1639 35.462 17.8118 35.3506 14.7439 34.2172C11.676 33.0838 9.05671 30.989 7.27661 28.2453C5.4965 25.5016 4.651 22.256 4.86619 18.9925C5.08138 15.729 6.34575 12.6225 8.47071 10.1363C10.5957 7.65011 13.4674 5.91741 16.6575 5.19664ZM37.7278 7.72673C38.3133 7.14065 38.3129 6.19091 37.7268 5.60541C37.1407 5.01992 36.191 5.02039 35.6055 5.60647L19.9995 21.2281L16.0606 17.2893C15.4749 16.7035 14.5251 16.7035 13.9393 17.2893C13.3535 17.8751 13.3535 18.8248 13.9393 19.4106L18.9393 24.4106C19.2207 24.692 19.6024 24.85 20.0004 24.8499C20.3983 24.8498 20.7799 24.6916 21.0612 24.4101L37.7278 7.72673Z",
    fill: "url(#check-circle-linear-gradient)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "check-circle-linear-gradient",
    x1: 20,
    y1: 1.82373,
    x2: 20,
    y2: 38.1571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9EED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ACC8B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGradient);
export default __webpack_public_path__ + "static/media/check-circle-gradient.cd95e0d94fabb28d995cd51e3f20b3ad.svg";
export { ForwardRef as ReactComponent };